module.exports = __webpack_public_path__ + "img/testing-services.25f5ec6.svg";